import template from './ko-date-range.html';
import './ko-date-range.css';
import ValueRange from '../../models/ValueRange.js';

class DateRangeVM
{
	constructor(params)
	{
		this.params = params;

		this.value = ko_helper.safe_observable(params?.value, '[,)');

		this.value_range = new ValueRange(this.value, {
			serialize_function: (val) => this.serializeDate(val),
			deserialize_function: (val) => this.deserializeDate(val)
		});

		this.from_label = ko.pureComputed(() => this.value_range.from_unbounded() === true ? '-' : (this.value_range.from_inclusive() ? '[' : '('));
		this.to_label = ko.pureComputed(() => this.value_range.to_unbounded() === true ? '-' : (this.value_range.to_inclusive() ? ']' : ')'));
		this.from_tooltip = ko.pureComputed(() => this.value_range.from_unbounded() === true ? 'Unbounded' : (this.value_range.from_inclusive() ? 'Inclusive' : 'Exclusive'));
		this.to_tooltip = ko.pureComputed(() => this.value_range.to_unbounded() === true ? 'Unbounded' : (this.value_range.to_inclusive() ? 'Inclusive' : 'Exclusive'));
	}

	serializeDate(val)
	{
		if (!val || val.trim() === '') return '';
		
		// Try parsing as YYYY-MM-DD (ISO format from server)
		let m = moment(val.trim(), 'YYYY-MM-DD', true);
		if (m.isValid()) {
			return m.format('YYYY-MM-DD');
		}
		
		// Fallback: try moment's default parsing
		m = moment(val.trim());
		return m.isValid() ? m.format('YYYY-MM-DD') : '';
	}

	deserializeDate(val)
	{
		if (!val) return '';
		
		let m = moment(val, 'YYYY-MM-DD', true);
		if (!m.isValid()) {
			m = moment(val);
		}
		return m.isValid() ? m.format('YYYY-MM-DD') : '';
	}
}

export default {
	name: 'ko-date-range',
	viewModel: DateRangeVM,
	module_type: 'ko',
	template: template
};
